import {
  Home,
  Calendar,
  Stethoscope,
  Users,
  Settings,
  Ambulance,
} from "lucide-react";
import { NavItem } from "../types/navbar.types";

export const FALLBACK_NAV_ITEMS: NavItem[] = [
  { path: "/dashboard", label: "Home", icon: Home },
  { path: "/consultation-list", label: "Consultations", icon: Stethoscope },
  { path: "/patients", label: "Patients", icon: Users },
  { path: "/appointments", label: "History", icon: Calendar },
  { path: "/emergency", label: "Emergency", icon: Ambulance },
  { path: "/settings", label: "Settings", icon: Settings },
];

export const FALLBACK_MOBILE_NAV_ITEMS: NavItem[] = [
  { path: "/dashboard", label: "Home", icon: Home },
  { path: "/consultation-list", label: "Consults", icon: Stethoscope },
  { path: "/patients", label: "Patients", icon: Users },
  { path: "/appointments", label: "History", icon: Calendar },
  { path: "/emergency", label: "Emergency", icon: Ambulance },
];

export const ALLOWED_AVATAR_DOMAINS = [
  "cdn.example.com",
  "images.gluviacare.com",
  "storage.googleapis.com",
  "s3.amazonaws.com",
];

export const API_TIMEOUT = 8000;
export const MAX_RETRIES = 3;
export const RETRY_DELAY = 1000;